export default "__VITE_ASSET__xSU9t876__"